<div class="tab-content">
  <!-- Admin controls for switching the employee list mode. -->
  <div *ngIf="BaseServices.roleId === '1'" class="mb-3">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="!withUserOnly"
          (click)="setWithUserOnlyMode(false)"
        >
          {{ "ALL_EMPLOYEES" | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="withUserOnly"
          (click)="setWithUserOnlyMode(true)"
        >
          {{ "EMPLOYEES_WITH_USERS" | translate }}
        </a>
      </li>
    </ul>
  </div>
  <div class="page-title">
    <span translate>EMPLOYEE_LIST</span>
    <span class="page-actions pull-right employee-license-toolbar" *ngIf="!isHideEmployee">
      <button
        *ngIf="isManageEmployeeRights && !isPortal"
        type="button"
        (click)="createEmployee()"
        class="btn btn-success"
      >
        <i class="pi pi-plus"></i>
        <span translate>EMPLOYEE</span>
      </button>
    </span>
  </div>
  <div class="table-view employee-table-container" *ngIf="!isHideEmployee">
    <!-- Table starts -->
    <p-table
      #employee
      styleClass="kuba-employee-table"
      [value]="employeeobj"
      [rows]="pageSize"
      [totalRecords]="totalItems"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      exportFilename="employeeobj"
      (onPage)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}: {{
        totalItems
      }}"
      [lazy]="true"
      [loading]="isLoading"
      (onSort)="onSort($event)"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="table-options">
            <div class="pull-right">
              <kuba-export
                [reportData]="employee.filteredValue || employee.value"
                [additionalData]="additionalData"
                [filters]="{
                  name: nameFilter,
                  number: numberFilter,
                  email: emailFilter,
                  mobile: mobileFilter,
                  status: selectedStatus,
                  department: departmentFilter,
                  position: positionFilter,
                  category: categoryFilter,
                  businessId: businessFilter,
                  userName: usernameFilter,
                  roleId: roleFilter,
                  withUserOnly: withUserOnly,
                  sortField: sortField,
                  sortOrder: sortOrder
                }"
                [exportAllData]="true"
                [getAllDataFn]="getAllEmployeesForExport"
              ></kuba-export>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <!-- Checkboxes -->
          <th class="employee-select" *ngIf="isManageEmployeeRights">
            <p-checkbox
              [(ngModel)]="headerCheckboxChecked"
              [binary]="true"
              (onChange)="onHeaderSelectionChange($event)"
            >
            </p-checkbox>
          </th>
          <!-- Employee Number -->
          <th class="employee-number" pSortableColumn="Number">
            {{ "EMPLOYEE_NUMBER" | translate }}
            <p-sortIcon field="Number"></p-sortIcon>
          </th>
          <!-- Name -->
          <th class="employee-name">
            {{ "NAME" | translate }}
          </th>
          <!-- Department -->
          <th class="employee-department">
            {{ "DEPARTMENT" | translate }}
          </th>
          <!-- Mobile number -->
          <th class="employee-mobile">
            {{ "MOBILE" | translate }}
          </th>
          <!-- Email -->
          <th class="employee-email">
            {{ "EMAIL" | translate }}
          </th>
          <!-- Position -->
          <th class="employee-position">
            {{ "POSITION" | translate }}
          </th>
          <!-- Percentage -->
          <th
            class="employee-percentage"
            *ngIf="!isPortal"
            pSortableColumn="Percentage"
          >
            {{ "PERCENTAGE" | translate }}
            <p-sortIcon field="Percentage"></p-sortIcon>
          </th>
          <!-- Status -->
          <th class="employee-status" [class.hidden]="!isManageEmployeeRights">
            {{ "STATUS" | translate }}
          </th>
          <!-- Business name if in portal -->
          <th class="employee-business" *ngIf="isPortal">
            {{ "BUSINESS_NAME" | translate }}
          </th>
        </tr>
        <tr>
          <!-- Empty filter field for Checkboxes -->
          <th *ngIf="isManageEmployeeRights"></th>
          <!-- Filter field for Employee number -->
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="numberFilter"
              (input)="onNumberFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <!-- Filter field for Name -->
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="nameFilter"
              (input)="onNameFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <!-- Filter field for Department -->
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="departmentFilter"
              (input)="onDepartmentFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <!-- Filter field for Mobile -->
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="mobileFilter"
              (input)="onMobileFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <!-- Filter field for Email -->
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="emailFilter"
              (input)="onEmailFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <!-- Filter field for Position -->
          <th>
            <input
              pInputText
              type="text"
              [(ngModel)]="positionFilter"
              (input)="onPositionFilterChange($any($event.target)?.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <!-- Empty filter field for Percentage -->
          <th *ngIf="!isPortal"></th>
          <!-- Filter field for Status -->
          <th [class.hidden]="!isManageEmployeeRights">
            <p-select
              [options]="statuses"
              [(ngModel)]="selectedStatus"
              #statusDropdown
              (onChange)="onStatusChanged($event, statusDropdown)"
              styleClass="p-column-filter"
              placeholder=""
              [filterBy]="null"
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <!-- Filter field for Business name if in portal -->
          <th *ngIf="isPortal">
            <p-select
              [options]="businesses"
              [(ngModel)]="businessFilter"
              (onChange)="onBusinessChanged($event, businessDropdown)"
              #businessDropdown
              styleClass="p-column-filter"
              placeholder="{{ 'SELECT' | translate }}"
              [showClear]="true"
              [filter]="true"
              optionLabel="label"
              optionValue="value"
            >
              <ng-template let-business pTemplate="item">
                {{ business.label | translate }}
              </ng-template>
            </p-select>
          </th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-employee>
        <!-- Checkbox -->
        <tr>
          <td class="employee-select" *ngIf="isManageEmployeeRights">
            <p-checkbox
              [binary]="true"
              [ngModel]="allSelectedEmployees.has(employee.Id)"
              (onChange)="
                onRowSelectionChange({
                  checked: $event.checked,
                  data: employee
                })
              "
            >
            </p-checkbox>
          </td>
          <!-- Employee number -->
          <td class="employee-number">
            <span
              translate
              pTooltip="{{ employee.Number }}"
              tooltipPosition="top"
              >{{ employee.Number }}</span
            >
          </td>

          <!-- Name -->
          <td class="employee-name">
            <div class="employee-identity">
              <ng-template #avatarImage>
                <img
                  [src]="
                    isValidImageExtension(employee.Avatar)
                      ? employee.Avatar
                      : '/assets/icons/default_profile.jpg'
                  "
                  (error)="onAvatarError($event)"
                  alt=""
                  width="40"
                  height="40"
                  class="kuba-employee-avatar"
                />
              </ng-template>
              <ng-container *ngIf="!isPortal">
                <a
                  class="employee-avatar-link"
                  *ngIf="isManageEmployeeRights; else avatarWithoutLink"
                  [routerLink]="['./../edit', employee.Id]"
                  [attr.aria-label]="employee.Name"
                >
                  <ng-container *ngTemplateOutlet="avatarImage"></ng-container>
                </a>
                <ng-template #avatarWithoutLink>
                  <span class="employee-avatar-link">
                    <ng-container *ngTemplateOutlet="avatarImage"></ng-container>
                  </span>
                </ng-template>
              </ng-container>
              <div class="employee-name-text">
                <div
                  *ngIf="
                    isManageEmployeeRights &&
                      !isPortal &&
                      (RoleIdCommon == 3 ||
                        (RoleIdCommon == 5 &&
                          employee.BusinessDepartmentId ==
                            BusinessDepartmentId));
                    else elseBlock
                  "
                >
                  <a [routerLink]="['./../edit', employee.Id]"
                    ><span
                      pTooltip="{{ employee.Name }}"
                      tooltipPosition="top"
                      >{{ employee.Name }}</span
                    ></a
                  >
                </div>
                <ng-template #elseBlock
                  ><span>{{ employee.Name }}</span></ng-template
                >
              </div>
            </div>
          </td>
          <!-- Department -->
          <td class="employee-department">
            <span>{{ employee.DepartmentName }}</span>
          </td>
          <!-- Mobile -->
          <td class="employee-mobile">
            <span>{{ employee.Mobile }}</span>
          </td>
          <!-- Email -->
          <td class="employee-email">
            <span
              translate
              pTooltip="{{ employee.Email }}"
              tooltipPosition="top"
              >{{ employee.Email }}</span
            >
          </td>
          <!-- Position -->
          <td class="employee-position">
            <span>{{ employee.PositionName }}</span>
          </td>
          <!-- Percentage -->
          <td class="employee-percentage" *ngIf="!isPortal">
            <span>{{ employee.Percentage }}</span>
          </td>
          <!-- Status -->
          <td
            class="employee-status"
            [class.hidden]="!isManageEmployeeRights"
            *ngIf="guest || isUserRole"
          >
            <span>{{ employee.StatusKey | translate }}</span>
          </td>
          <td
            class="employee-status"
            [class.hidden]="!isManageEmployeeRights"
            *ngIf="!guest && !isUserRole"
          >
            <span>
              <a
                href="javascript:void(0);"
                (click)="editStatus(employee['Id'], employee['StatusKey'])"
                routerLinkActive="active"
                >{{ employee.StatusKey | translate }}</a
              >
            </span>
          </td>
          <!-- Business name if in portal -->
          <td class="employee-business" *ngIf="isPortal">
            <span>{{ employee.BusinessName }}</span>
          </td>
        </tr>
      </ng-template>
      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="isManageEmployeeRights ? 9 : 7">
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
      <!-- Footer -->
      <ng-template pTemplate="summary">
        <div class="ui-helper-clearfix" *ngIf="isManageEmployeeRights">
          <div class="footer-data">
            <div *ngIf="!guest && !isPortal" class="text-left">
              <button
                class="btn btn-danger"
                (click)="deleteEmployee(selectedEmployee)"
              >
                <i class="pi pi-trash"></i>
                <span translate>DELETE_CHECKED</span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
    <!-- Table ends -->
  </div>
  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-question-circle"
    width="425"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>
  <router-outlet></router-outlet>
</div>

<p-dialog
  header="{{ 'NOTIFICATION' | translate }}"
  [(visible)]="showNotification"
  [style]="{ width: '600px' }"
  [resizable]="false"
  [draggable]="false"
>
  <span translate> SELECT_ONERECORD </span>
</p-dialog>
<p-dialog
  header="{{ 'NOTIFICATION' | translate }}"
  [(visible)]="isRightsEnabled"
  [style]="{ width: '600px' }"
  [resizable]="false"
  [draggable]="false"
>
  <span translate> DONT_HAVE_RIGHTS </span>
</p-dialog>
<!--Panel Loader-->

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>

<!--Panel Loader-->
